import { render, staticRenderFns } from "./AcessoDireto.vue?vue&type=template&id=5380a67d&"
import script from "./AcessoDireto.vue?vue&type=script&lang=js&"
export * from "./AcessoDireto.vue?vue&type=script&lang=js&"
import style0 from "./AcessoDireto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports